
export interface SidebarDataItem  {
    title: string;
    link: string;
}


export const SidebarData :SidebarDataItem[] = [
    {
        title: "Home",
        link: "/"
    },
    {
        title: "About",
        link: "/about"
    },
    {
        title: "Resume",
        link: "/resume"
    }
]